import { Menu, Transition } from '@headlessui/react';
import { ArrowDownTrayIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import React, { Fragment } from 'react';

export interface BandwidthExportMenuProps {
  disabled?: boolean;
  onExportPdf: () => void;
  onExportExcel: () => void;
  ariaLabel: string;
}

const BandwidthExportMenu: React.FC<BandwidthExportMenuProps> = ({
  disabled = false,
  onExportPdf,
  onExportExcel,
  ariaLabel,
}) => (
  <Menu as="div" className="relative z-[60] inline-block text-left">
    <Menu.Button
      type="button"
      disabled={disabled}
      className="inline-flex items-center gap-1 rounded-md border border-indigo-100 bg-white px-2 py-1 text-xs font-medium text-slate-700 shadow-sm transition-colors hover:border-indigo-200 hover:bg-indigo-50/50 hover:text-indigo-950 disabled:cursor-not-allowed disabled:opacity-50"
      aria-label={ariaLabel}
    >
      <ArrowDownTrayIcon className="h-3.5 w-3.5 shrink-0" aria-hidden />
      Export
      <ChevronDownIcon className="h-3 w-3 shrink-0 text-slate-500" aria-hidden />
    </Menu.Button>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items className="absolute right-0 z-[60] mt-1 w-36 origin-top-right rounded-md border border-slate-200 bg-white py-1 shadow-lg ring-1 ring-slate-950/5 focus:outline-none">
        <Menu.Item>
          {({ active }) => (
            <button
              type="button"
              className={`${active ? 'bg-slate-50 text-slate-900' : 'text-slate-700'} block w-full px-3 py-2 text-left text-xs`}
              onClick={onExportPdf}
            >
              PDF
            </button>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <button
              type="button"
              className={`${active ? 'bg-slate-50 text-slate-900' : 'text-slate-700'} block w-full px-3 py-2 text-left text-xs`}
              onClick={onExportExcel}
            >
              Excel
            </button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Transition>
  </Menu>
);

export default BandwidthExportMenu;
